// @ts-nocheck 1d32d85a
import * as util from '#packages/util';

function getLocale(/*editorAPI, appData, token*/) {
  return util.editorModel.languageCode;
}

export { getLocale };
